import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import candidateSkillsetsService from "../service-api/candidateSkillSetsService";

// Initial state
const initialState = {
  allCandidateSkillSets: [],
  data: [],
  error: null,
  isLoading: true,
};

export const fetchAllCandidateSkillSets = createAsyncThunk(
  "data/fetchSkillSets",
  async () => {
    const response =
      await candidateSkillsetsService.fetchAllCandidateSkillSets();
    return response.data;
  }
);

export const fetchCandidateSkillSets = createAsyncThunk(
  "data/fetchSkillSets",
  async (id) => {
    const response = await candidateSkillsetsService.fetchCandidateSkillSets(
      id
    );
    return response.data;
  }
);

export const addCandidateSkillSet = createAsyncThunk(
  "data/addCandidateSkillset",
  async (obj) => {
    const response = await candidateSkillsetsService.addCandidateSkillSkillSet(
      obj
    );
    return response.data;
  }
);

export const deleteCandidateSkillSet = createAsyncThunk(
  "data/deleteCandidateSkillset",
  async (id) => {
    const response = await candidateSkillsetsService.addCandidateSkillSkillSet(
      id
    );
    return response.data;
  }
);

// Create slice
const candidateSkillSetsSlice = createSlice({
  name: "candidateskillsets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCandidateSkillSets.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllCandidateSkillSets.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allCandidateSkillSets = action.payload.value;
      })
      .addCase(fetchAllCandidateSkillSets.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    // builder
    //   .addCase(fetchCandidateSkillSets.pending, (state) => {
    //     state.isLoading = true;
    //   })
    //   .addCase(fetchCandidateSkillSets.fulfilled, (state, action) => {
    //     state.isLoading = false;
    //     state.data = action.payload.value;
    //   })
    //   .addCase(fetchCandidateSkillSets.rejected, (state, action) => {
    //     state.isLoading = false;
    //     state.error = action.error.message;
    //   });

    builder
      .addCase(addCandidateSkillSet.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addCandidateSkillSet.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(addCandidateSkillSet.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default candidateSkillSetsSlice.reducer;
